<template>
  <b-button
      @click="() => { modalState = true }"
      size="sm"
      :disabled="disabled"
      :variant="(httpRequestInProgress) ? 'success': 'primary'"
      block
      v-show="!userPreferenceStore.coi.lightMode"
  ><!-- button -->
    <span v-if="httpRequestInProgress">
      <b-spinner
          type="grow"
          label="Loading..."
          small
      ></b-spinner>
      </span>
    <span v-else-if="customerOrder.destroyedByCustoms != null">Vom Zoll vernichtet</span>
    <span v-else>Als Zollvernichtung markieren</span>
    <b-modal id="modal-unfreeze-order"
             v-model="modalState"
             title="Markieren als Zollvernichtung"
             @ok="submit()"
             cancel-title="Abbrechen"
             size="md"
    ><!-- modal -->
      <p>Nur für den Verlust der Sendung auf dem Versandweg auszuwählen!</p>
      <p>Achtung: nicht für Sendungen die beschädigt oder falsch beim Kunden ankamen gedacht!!!</p>
    </b-modal>
  </b-button>
</template>

<script>
import { useUserPreferenceStore } from '../../stores/UserPreferenceStore';

export default {
  setup(){
    const userPreferenceStore = useUserPreferenceStore();
    return {userPreferenceStore}
  },
  name: "COIActionBarDeathCertificate",
  props: ['customerOrder','authorization'],
  data() {
    return {
      modalState: false,
      httpRequestInProgress: false
    };
  },
  modalState: false,
  httpRequestInProgress: false,
  computed: {
    disabled: function() {
      // TODO: is it needed to disable the function in some cases?
      return this.customerOrder.destroyedByCustoms != null;
    }
  },
  methods: {
    submit() {
      this.httpRequestInProgress = true;

      let payload = {
        customerOrderId: this.customerOrder.id
      }

      Promise.all([
        axios.post('/customerorder/action/destroyed_by_customs', payload),
        new Promise(r => setTimeout(r, 500))
      ]).then( response => {
        this.customerOrder.destroyedByCustoms = true;
        this.httpRequestInProgress = false;
      }).catch( error => {
        alert(error.response.data)
        console.error(error);
        this.httpRequestInProgress = false;
      });
    }
  }
}
</script>